var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "100px",
    viewBox: "0 0 88 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-73.8%",
    y: "-57.4%",
    width: "247.6%",
    height: "214.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.7 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.9245306%",
    y1: "73.264822%",
    x2: "19.7530864%",
    y2: "0%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018BB0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B38B",
    offset: "80.0860916%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D26F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WIP-Real-screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contracting-Service-Portal-Marketing-Home-opt-2",
    transform: "translate(-599.000000, -3310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    filter: "url(#filter-1)",
    transform: "translate(622.000000, 3333.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,0 C32.5979797,0 42,9.40202025 42,21 C42,30.3231682 35.9244789,38.2273225 27.5166231,40.9692764 L21,54 L14.485383,40.9699305 C6.07648747,38.2285797 0,30.3239097 0,21 C0,9.40202025 9.40202025,0 21,0 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 21,
    cy: 21,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(11.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "9.82828968 16.8173806 9.82828968 22.4231741 13.1069337 16.8173806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.2748228 11.2115871 1.5696535e-13 16.8173806 4.91414484 14.0163945"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#73C3D5",
    fillRule: "nonzero",
    points: "5.4905575e-14 16.8173806 6.55346687 16.8173806 4.91414484 14.0163945"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#73C3D5",
    fillRule: "nonzero",
    points: "13.1069337 16.8173806 19.6604006 5.60579353 9.82828968 11.2115871 9.82828968 16.8173806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5DC79",
    fillRule: "nonzero",
    points: "9.82828968 22.4231741 19.6604006 16.8173806 13.1069337 16.8173806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5DC79",
    fillRule: "nonzero",
    points: "4.91414484 14.0163945 9.82828968 11.2115871 9.82828968 0 3.2748228 11.2115871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B5DC79",
    fillRule: "nonzero",
    points: "6.55346687 16.8173806 9.82828968 22.4231741 9.82828968 16.8173806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#73C3D5",
    fillRule: "nonzero",
    points: "2.58379177e-13 5.60579353 2.58379177e-13 16.8173806 3.2748228 11.2115871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#009ABF",
    fillRule: "nonzero",
    points: "19.6604006 5.60579353 13.1069337 16.8173806 19.6604006 16.8173806 19.6604006 5.60579353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#009ABF",
    fillRule: "nonzero",
    points: "9.82828968 11.2115871 4.91414484 14.0163945 6.55346687 16.8173806 9.82828968 16.8173806"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#009ABF",
    fillRule: "nonzero",
    points: "9.82828968 0 3.139307e-13 5.60579353 3.2748228 11.2115871"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/mapMarker.b1e750e4c5b5258a0ac3991b08ca8d8f.svg";
export { ForwardRef as ReactComponent };